import PropTypes from 'prop-types';

export default PropTypes.shape({
  uuid: PropTypes.string,
  userName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  active: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf([
      'true',
      'false'
    ])
  ]),
});


// WEBPACK FOOTER //
// ./src/shapes/user.js